import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import ModalTrigger from "../../Common/ModalTrigger";
import ButtonsSelect from "../../Common/ButtonsSelect";
import MultiLineChart from "../../Charts/MultiLineChart";
import csv2 from "../../../Data/EUMACP/Overview/EU-MACP-Overview-MRL-Exceedances-rate-comparison-2014-2017-2020-Line-chart.csv";
import { useState } from "react";

// import classes from '../../'

const FourthRow = () => {
  const aboveMRL = "Above MRL";
  const belowMRL = "Below or equal to MRL";
  const [mrlFilter, setMrlFilter] = useState("Above MRL");
  const handleMRLExceedanceButtonClick = (evt) => {
    if (evt === 0) {
      if (aboveMRL !== mrlFilter) {
        setMrlFilter(aboveMRL);
      }
    } else {
      if (belowMRL !== mrlFilter) {
        setMrlFilter(belowMRL);
      }
    }
  };

  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{
        marginTop: { xs: "50px", sm: "50px", md: "90px" },
        alignItems: { sm: "center", md: "center" },
        textAlign: { sm: "center", md: "left" },
      }}
      className="four-one-wrapper"
    >
      <Grid
        item
        xs
        p={3}
        className="four-one"
        sx={{ maxWidth: { md: "450px !important" } }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",

            width: "100%",
          }}
        >
          <h3>Comparison of MRL exceedance rates in 2023, 2020 and 2017</h3>
          <p className="paragraph">
            The EU MACP covers the most consumed food products in Europe. The
            listed products are distributed across a three-year cycle so that
            every three years the same products are analysed.
          </p>
          <p>A comparison between 2017 and 2023 results shows that the overall <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="MRL exceedance rate"
            />{" "} increased from 1.7% in 2017 to 1.9% in 2023. In 2017, bovine liver was not covered by the current EU MACP.</p>

          {/* <p className='paragraph'>
						The increase is due to pesticide residues in grapefruits imported
						from{' '}
						<ModalTrigger
							style={{ color: '#22294D', cursor: 'pointer' }}
							text='third countries'
						/>
						. The reporting countries flagged the issue in 2021, and in the same
						year, the European Commission increased border controls. With
						grapefruits excluded, the average MRL exceedance rate for all other
						tested foodstuff was 1.4% in 2021, the same as in 2018.
					</p> */}
          {/* <p className="paragraph">
          Data on individual food commodities can be found on the right.
          </p> */}
          {/* <p className='paragraph'>
						Exceedance rates fell for broccoli, chicken eggs, melons, table
						grapes and virgin olive oil.
					</p> */}
        </Box>
      </Grid>
      <Grid item xs p={3} sx={{ width: "100%" }} className="four-two">
        <Box>
          <ButtonsSelect
            firstButton=">MRL"
            secondButton="≤MRL"
            onButtonClick={handleMRLExceedanceButtonClick}
          />
          <MultiLineChart
            legendPosition="right"
            title="MRL exceedance rate comparison (2017, 2020, 2023)"
            csv={csv2}
            filter={mrlFilter}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default FourthRow;
